module.exports = __webpack_public_path__ + "img/BecomeIns-3.a54f19ad.svg";